var map = {
	"./ico-arrow.svg": "CKTK",
	"./ico-attachment.svg": "/eIL",
	"./ico-branding.svg": "V1fx",
	"./ico-content.svg": "MD19",
	"./ico-discovery.svg": "3NtV",
	"./ico-mobile.svg": "xcc3",
	"./ico-project.svg": "FULb",
	"./ico-qa.svg": "sYwO",
	"./ico-star.svg": "a6p8",
	"./ico-strategy.svg": "DA8z",
	"./ico-success.svg": "4Jd7",
	"./ico-tick.svg": "hCVu",
	"./ico-ui.svg": "MLJe",
	"./ico-ux.svg": "dYbD",
	"./ico-web.svg": "ssmy"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DzQ2";